const PATH_PREFIX = '/admin/procurement/:targetType/:targetID';

export default [
  {
    name: 'procurement.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'procurement.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'procurement.ask_for_quotes',
    path: `${PATH_PREFIX}/:mode/ask_for_quote`,
  },
  {
    name: 'procurement.ask_for_quote',
    path: `${PATH_PREFIX}/:mode/ask_for_quote/:docID`,
  },
  {
    name: 'procurement.request_for_quotes',
    path: `${PATH_PREFIX}/:mode/request_for_quote`,
  },
  {
    name: 'procurement.request_for_quote',
    path: `${PATH_PREFIX}/:mode/request_for_quote/:docID`,
  },
  {
    name: 'procurement.list',
    path: `${PATH_PREFIX}/:mode/:type`,
  },
  {
    name: 'procurement.details',
    path: `${PATH_PREFIX}/:mode/:type/:docID`,
  },
];
